<template>
  <div class="photo_wall">
     <div class="photo_wall_content" v-if="photoList.length > 0">
        <div class="photo_wall_wrapper">
            <div class="photo_wall_content_top" ref="wrapper">
               <div class="photo_wall_content_top_pics">
                  <div class="photo_wall_content_top_pics_box"
                  v-for="(item,index) in photoList" :key="item.id+index"
                    @touchstart="onTouchstart($event,index)"
                     >
                      <!--  -->
                     <!-- @touchmove="onTouchmove($event,index)"
                     @touchend="onTouchend($event,index)" -->
                        <img :src="item.pic" class="photo_wall_content_top_pics_box_img">
                     </div>
               </div>
            </div>
            <div class="photo_wall_content_bottom">
               <div class="photo_wall_content_bottom_editBtn" v-show="!isEdit">
                  <span @click="onEdit">编辑</span>
                  </div>
               <div class="photo_wall_content_bottom_operate" v-show="isEdit">
                  <van-uploader :after-read="afterRead"  accept="image/jpg, image/jpeg">
                     <div class="photo_wall_content_bottom_operate_upload">
                        <span>上传照片</span>
                     </div>
                  </van-uploader>
                  <div class="photo_wall_content_bottom_operate_delete" :class="dragMove ? 'is_active' : ''">
                     <i class="icon_del"></i>
                     <span class="photo_wall_content_bottom_operate_delete_cue">将图片拖到这里可删除</span>
                  </div>
               </div>
            </div>
        </div>
     </div>
     <div class="photo_wall_noData" v-if="photoList.length == 0">
        <p class="photo_wall_noData_cue">{{msg}}</p>
        <van-uploader :after-read="afterRead" accept="image/jpg, image/jpeg">
           <div class="photo_wall_noData_btns">上传照片</div>
        </van-uploader>
     </div>
  </div>
</template>

<script>
import { _upload } from '../../api/family-archives';
import { _saveStudentPhotoWall } from '../../api/children-file';
import BScroll from "better-scroll";
export default {
   name:"photo-wall",
   props:{
      componentData:{
         type:Object
      },
   },
   components:{},
   data() {
      return {
         photoList:[], // 照片列表
         msg:"您还未上传过照片，快来上传吧。",
         isEdit:false, // 图片是否处于可拖动状态
         startX:0, // 图片上触摸点的x轴位移
         startY:0, // 图片上的触摸点的Y轴位移
         dragMove:false, // 图片是否可以移动
         curIndex:0, // 当前拖动图片的标识
         identifier:null,// 标识触摸的唯一ID
         curImg:null, // 拖动的图片
         bs:null, // 页面滚动的插件
      }
   },
   watch:{
      componentData:{
         handler(list) {
            if(list.photoWallList.length > 0){
               list.photoWallList.map(item=>{
                  // item.pic = 'http://' + location.host + '/' + item.photo;
                  item.pic =item.photo;
               })
            }
            this.photoList = JSON.parse(JSON.stringify(list.photoWallList));
            this.isEdit = false;
            if(this.bs){
               setTimeout(()=>{
                  this.initSroll()
               },200)
            }
         },
         immediate:true,
         deep:true
      }
   },
   computed:{
      // 页面的宽度
      fWidth:function() {
         return document.getElementsByClassName('photo_wall')[0].clientWidth;
      },
      // 页面的高度
      fHeight:function() {
         return document.getElementsByClassName('photo_wall')[0].clientHeight;
      },
      // 页面除去内边距的宽度
      pWidth:function() {
         return document.getElementsByClassName('photo_wall_wrapper')[0].clientWidth;
      },
      // 页面除去内边距的高度
      pHeight:function() {
         return document.getElementsByClassName('photo_wall_wrapper')[0].clientHeight;
      },
      // 删除区域的宽度
      targetWidth:function() {
         return document.getElementsByClassName('photo_wall_content_bottom_operate_delete')[0].clientWidth;
      },
      // 删除区域的高度
      targetHeight:function() {
         // height+边框值
         return document.getElementsByClassName('photo_wall_content_bottom_operate_delete')[0].clientHeight + 2;
      },

   },
   created() {

   },
   mounted() {
      this.$nextTick(()=>{
         setTimeout(()=>{
            this.initSroll()
         },200)
      })
      
   },
   methods:{
      initSroll() {
         if(!this.$refs.wrapper){
            return;
         }
         this.bs = new BScroll(this.$refs.wrapper,{
            pullUpLoad: true, // 不触发上拉事件
            scrollbar: false, // 展示滚动条
            pullDownRefresh: false, // 开启下拉刷新事件，需要配合内部配置使用，这里目前没有用到
            scrollX:true, 
            scrollY:false,// 关闭纵向滚动功能
            bounce:false, // 关闭滚动到边缘时的回弹动作
            stopPropagation:true,// 阻止事件冒泡
            quadrant:2, // 父元素或者祖先元素旋转的角度为 (45, 135]，quadrant 建议为 2，尤其是 90 度，quadrant 必须为 2
         })
      },
      // 判断是否是单点触控
       processEvent(e) {
         if(e.changedTouches){
            // 单点触控
            let currentTouch = null;
            if(e.type == 'touchstart'){
               // 假如当前无触摸点，则新建一个
               if(this.identifier == null){
                  this.identifier = e.changedTouches[0].identifier;
                  currentTouch = e.changedTouches[0];
               }
               return true
            }else if(e.type == 'touchmove'){
               // 判断触发当前事件的触摸点是否有identifier对应的触摸点
               for(let i=0;i < e.changedTouches.length; i++){
                  if(e.changedTouches[i].identifier == this.identifier){
                     currentTouch = e.changedTouches[i];
                     break;
                  }
               }
               if(!currentTouch){
                  return false
               }else{
                  return true
               }
            }else if(e.type == 'touchend' || e.type == 'touchcancel'){
               // 判断触发当前事件的触摸点是否有identifier对应的触摸点
               for(let i=0;i < e.changedTouches.length; i++){
                  if(e.changedTouches[i].identifier == this.identifier){
                     currentTouch = e.changedTouches[i];
                     break;
                  }
               }
               if(currentTouch){
                  this.identifier = null;
                  return true;
               }else{
                  return false;
               }
            }
         }
      },
      onTouchstart(e,index) {
               // 唯一标识初始化
            this.identifier = null;
            this.curImg = null;

            if(!this.processEvent(e)){
               return
            }
            e.preventDefault();
            this.curIndex = index
            if(!this.isEdit){
               return
            }
            if(this.dragMove){
               return
            }
            // 原点为左上角的初始化移动距离
            this.startX = 0;
            this.startY = 0;

            let wrapper = document.getElementsByClassName("photo_wall_content_top_pics")[0];
            wrapper.style.transform = "none";
            // 计算位移--start
            /* 横屏后，浏览器的x,y方向没有改变，原点还是左上角，从手机正常竖屏方向看，此时的pageX为触摸点离左侧的距离，pageY为触摸点离顶部的距离,
               而与元素绑定的相关属性则因为旋转，原点为右上角，从手机横屏方向看，e.target.offsetTop为触摸的盒子离顶部的距离，e.target.offsetLeft为触摸的盒子离左侧的距离*/

            // 手机正常竖屏,手指触摸点最初始的与左侧的距离 = 该页面宽度(this.fHeight) - 触摸点离该页面左侧距离(e.touches[0].pageX) - 可移动区域与页面之间的右边距((this.fHeight - this.pHeight)/2) - 触摸的盒子离顶部的距离（e.target.offsetTop，原点为右上角）
            this.startX = this.fHeight - e.touches[0].pageX - (this.fHeight - this.pHeight)/2 - e.target.offsetTop;

            // 手机正常竖屏,手指触摸点最初始的与顶部的距离 = 触摸点离该页面顶部距离(e.touches[0].pageY) - 可移动区域与页面之间的上边距((this.fHeight - this.pHeight)/2) - 触摸的盒子离左侧的距离（e.target.offsetLeft，原点为右上角）
            this.startY = e.touches[0].pageY - (this.fWidth - this.pWidth)/2 - e.target.offsetLeft;
            // 计算位移结束 --end
            // 触摸的盒子
            let curImg = document.getElementsByClassName(e.touches[0].target.className)[index];
            this.curImg = curImg
            // 触摸盒子的初始化位移值
            this.curImg.style.position = 'absolute';
            this.curImg.style.left = e.target.offsetLeft + 'px';
            this.curImg.style.top = e.target.offsetTop + 'px';

            let _this = this;

            this.curImg.removeEventListener('touchmove',_this.onTouchmove)
            this.curImg.removeEventListener('touchend',_this.onTouchend)
            this.curImg.addEventListener('touchmove',_this.onTouchmove)
            this.curImg.addEventListener('touchend',_this.onTouchend)
      },
      onTouchmove(e) {
         // 移动时不能滚动
         if(!this.processEvent(e)){
            return
         }

         if(!this.isEdit){
            return
         }
         this.dragMove = true;

         e.preventDefault();
         // 从手机横屏方向看，原点为右上角
         // 左位移 = 触摸点离该页面顶部距离(e.touches[0].pageY) - 可移动区域与页面之间的上边距((this.fHeight - this.pHeight)/2) - 手指触摸点最初始的与顶部的距离(this.startY)
         let left = e.touches[0].pageY - (this.fWidth - this.pWidth)/2 - this.startY;
         // 顶部位移 = 该页面宽度(this.fHeight) - 触摸点离该页面左侧距离(e.touches[0].pageX) - 可移动区域与页面之间的右边距((this.fHeight - this.pHeight)/2) - 手指触摸点最初始的与左侧的距离（this.startX）
         let top = this.fHeight - e.touches[0].pageX - (this.fHeight - this.pHeight)/2 - this.startX;
         
         // 判断移动的最小和最大的位移，并计算最小和最大的位移
         if(left <= 0){
            left = 0;
         }
         if(left >= (this.pWidth - e.target.clientWidth)){
            left = this.pWidth -  e.target.clientWidth;
         }
         if(top <= 0){
            top = 0;
         }
         if(top >= (this.pHeight - e.target.clientHeight)){
            top = this.pHeight - e.target.clientHeight;
         }

         this.curImg.style.left = left + 'px';
         this.curImg.style.top = top + 'px';

      },
      onTouchend(e) {
         if(!this.processEvent(e)){
            return
         }
         if(!this.isEdit){
            return
         }
          e.preventDefault();

         let left =  this.curImg.offsetLeft ; // 拖动图片距离左侧的距离
         let top =  this.curImg.offsetTop +  this.curImg.clientHeight; // 拖动图片底部距离顶部的距离

         // 删除区域的盒子
         let target = document.getElementsByClassName('photo_wall_content_bottom_operate_delete')[0];
         // 判断拖动的盒子是否进入删除区域，依据为拖动的盒子与删除区域盒子有重叠的区域
         if(target.offsetTop < top  &&
         (target.offsetTop + this.targetHeight) >= top &&
         (target.offsetLeft < left || target.offsetLeft < left +  this.curImg.clientWidth)&&
         target.offsetLeft + this.targetWidth >= left ){
            // 删除图片
            this.delPhotos(this.curIndex)
            this.startX = 0;
            this.startY = 0;
            this.dragMove = false;
         }else{ // 在删除图片区域以外都将图片都还回去
             this.curImg.style.left = '0px';
             this.curImg.style.top = '0px';
             this.curImg.style.position = 'relative';
             this.dragMove = false;
         }
      },
      onEdit() {
         this.isEdit = true;
      },
      // 文件读取后的回调函数
      afterRead(files) {
         if(this.photoList.length >= 5){
            Toast({message:'最多只能上传5张图片',className:'rotation'});
            return;
         }
         const data = new FormData()
			data.append('file',files.file)
			_upload(data).then((res)=>{
			  if(res.code =='200'){
              let params = {
                 id:"",
                 studentId:this.componentData.studentId,
                 photo:res.data,
                 pic:files.content,
                 deleteFlag:0,
              }
               this.savePhotos(params)

			  }else{
			    Toast({message:'上传失败',className:'rotation'});
			  }
			})
      },
      // 保存上传的图片
      savePhotos(params) {
         let dataObj = {
            id:params.id,
            studentId:params.studentId,
            photo:params.photo,
            deleteFlag:0,
         }
         _saveStudentPhotoWall(dataObj).then(res=>{
            if(res.code == 200){
               params.id = res.data.id;
               this.photoList.push(params);
               Toast({message:'上传照片成功',className:'rotation'})
               this.$emit('addPhoto',this.photoList)
               setTimeout(()=>{
                  this.initSroll()
               },200)
            }else{
               Toast({message:res.message,className:'rotation'})
            }
         })
      },
      // 删除图片
      delPhotos(curIndex) {
         let params = {};
         this.photoList.map((item,index)=>{
            if(index == curIndex){
               params = {
                  id:item.id,
                  studentId:item.studentId,
                  photo:item.photo,
                  deleteFlag:1
               }
            }
         })
         _saveStudentPhotoWall(params).then(res=>{
            if(res.code == 200){
               Toast({message:'删除照片成功',className:'rotation'})
               this.photoList.splice(curIndex,1)
               this.isEdit = false;
               this.$emit('delPhoto',this.photoList)
               setTimeout(()=>{
                  this.initSroll()
               },200)
            }else{
               Toast({message:res.message,className:'rotation'})
            }
         })
      },
      // 图片大小超出提示
      onOversize() {
         Toast({message:'图片大小不能超过2M',className:'rotation'})
      },
   }
}
</script>

<style lang="scss" scoped>
.photo_wall{
   width:100%;
   height:100%;
   .photo_wall_content{
      width:100%;
      height:100%;
      padding:52px 64px 42px 68px;
      .photo_wall_wrapper{
         width:100%;
         height:100%;
         position: relative;
      }
      .photo_wall_content_top{
         width:100%;
         // height:100%;
         overflow: hidden;
         // position: relative;
         .photo_wall_content_top_pics{
            // width:100%;
            width:auto;
            white-space: nowrap;
            overflow-x: auto;
            height:120px;
            // overflow-y:scroll;
            display: inline-block;
         }
         .photo_wall_content_top_pics_box{
            width:120px;
            height:120px;
            border-radius:8px;
            display: inline-block;
            vertical-align: top;
            &:not(:last-child){
               margin-right:20px;
            }
            img{
               width:120px;
               height:120px;
               border-radius:8px;
            }
         }
      }
      .photo_wall_content_bottom{
         margin-top:23px;
         // padding-left:63px;
         .photo_wall_content_bottom_editBtn{
            padding-top:2px;
            span{
               display: inline-block;
               width:72px;
               height:47px;
               background:url('../../assets/images/children-file/btn2.png') no-repeat;
               background-size:100% 100%;
               line-height:42px;
               text-align: center;
               color:#74410A;
               font-size:12px;
               font-weight:500;
               font-family: PingFangSC-Regular, PingFang SC;
            }
         }
         .photo_wall_content_bottom_operate{
            .photo_wall_content_bottom_operate_upload{
               padding-top:2px;
               display: inline-block;
               span{
                  display: inline-block;
                  width:96px;
                  height:47px;
                  background:url('../../assets/images/children-file/btn1.png') no-repeat;
                  background-size:100% 100%;
                  line-height:42px;
                  text-align: center;
                  color:#74410A;
                  font-size:12px;
                  font-weight:500;
                  font-family: PingFangSC-Regular, PingFang SC;
               }
            }
            .photo_wall_content_bottom_operate_delete{
               display: inline-block;
               width:220px;
               height:50px;
               border:1px solid transparent;
               text-align: center;
               margin-left:25px;
               line-height:50px;
               border-radius:8px;
               box-sizing: border-box;
               .icon_del{
                  display: inline-block;
                  width:14px;
                  height:16px;
                  background: url('../../assets/images/children-file/photo-del.png') no-repeat;
                  background-size:100% 100%;
                  vertical-align: middle;
               }
               .photo_wall_content_bottom_operate_delete_cue{
                  font-size:14px;
                  font-weight:400;
                  font-family: PingFangSC-Regular, PingFang SC;
                  margin-left:5px;
                  color:#666;
               }
               &.is_active{
                  border-color:#F55E55;
                  .photo_wall_content_bottom_operate_delete_cue{
                     color:#F55E55;
                  }
               }
            }
         }
      }
   }
   .photo_wall_noData{
      width:100%;
      height:100%;
      text-align: center;
      padding-top:113px;
      .photo_wall_noData_cue{
         color:#666;
         font-size:16px;
         font-weight:400;
         font-family: PingFangSC-Regular, PingFang SC;
         height:22px;
         line-height:22px;
         margin-bottom:13px;
      }
      .photo_wall_noData_btns{
         width:96px;
         height:47px;
         background: url('../../assets/images/children-file/btn1.png') no-repeat;
         background-size:100% 100%;
         line-height:42px;
         color:#74410A;
         font-weight:500;
         font-size:12px;
      }
   }
}
</style>
